import WebUrlScreen from 'features/urlDocumentScreens/WebUrlScreen/WebUrlScreen';
import React from 'react';

const WebUrlPage = () => {
  return <WebUrlScreen />;
};

export default WebUrlPage;
